/** @license React v16.5.2
 * schedule.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var c = null,
    e = !1,
    f = !1,
    g = "object" === typeof performance && "function" === typeof performance.now,
    l = {
  timeRemaining: g ? function () {
    var a = h() - performance.now();
    return 0 < a ? a : 0;
  } : function () {
    var a = h() - Date.now();
    return 0 < a ? a : 0;
  },
  didTimeout: !1
};

function m() {
  if (!e) {
    var a = c.timesOutAt;
    f ? n() : f = !0;
    p(q, a);
  }
}

function r() {
  var a = c,
      b = c.next;
  if (c === b) c = null;else {
    var d = c.previous;
    c = d.next = b;
    b.previous = d;
  }
  a.next = a.previous = null;
  a = a.callback;
  a(l);
}

function q(a) {
  e = !0;
  l.didTimeout = a;

  try {
    if (a) for (; null !== c;) {
      var b = exports.unstable_now();

      if (c.timesOutAt <= b) {
        do {
          r();
        } while (null !== c && c.timesOutAt <= b);
      } else break;
    } else if (null !== c) {
      do {
        r();
      } while (null !== c && 0 < h() - exports.unstable_now());
    }
  } finally {
    e = !1, null !== c ? m(c) : f = !1;
  }
}

var t = Date,
    u = "function" === typeof setTimeout ? setTimeout : void 0,
    v = "function" === typeof clearTimeout ? clearTimeout : void 0,
    w = "function" === typeof requestAnimationFrame ? requestAnimationFrame : void 0,
    x = "function" === typeof cancelAnimationFrame ? cancelAnimationFrame : void 0,
    y,
    z;

function A(a) {
  y = w(function (b) {
    v(z);
    a(b);
  });
  z = u(function () {
    x(y);
    a(exports.unstable_now());
  }, 100);
}

if (g) {
  var B = performance;

  exports.unstable_now = function () {
    return B.now();
  };
} else exports.unstable_now = function () {
  return t.now();
};

var p, n, h;

if ("undefined" === typeof window) {
  var C = -1;

  p = function p(a) {
    C = setTimeout(a, 0, !0);
  };

  n = function n() {
    clearTimeout(C);
  };

  h = function h() {
    return 0;
  };
} else if (window._schedMock) {
  var D = window._schedMock;
  p = D[0];
  n = D[1];
  h = D[2];
} else {
  "undefined" !== typeof console && ("function" !== typeof w && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" !== typeof x && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
  var E = null,
      F = !1,
      G = -1,
      H = !1,
      I = !1,
      J = 0,
      K = 33,
      L = 33;

  h = function h() {
    return J;
  };

  var M = "__reactIdleCallback$" + Math.random().toString(36).slice(2);
  window.addEventListener("message", function (a) {
    if (a.source === window && a.data === M) {
      F = !1;
      var b = exports.unstable_now();
      a = !1;
      if (0 >= J - b) if (-1 !== G && G <= b) a = !0;else {
        H || (H = !0, A(N));
        return;
      }
      G = -1;
      b = E;
      E = null;

      if (null !== b) {
        I = !0;

        try {
          b(a);
        } finally {
          I = !1;
        }
      }
    }
  }, !1);

  var N = function N(a) {
    H = !1;
    var b = a - J + L;
    b < L && K < L ? (8 > b && (b = 8), L = b < K ? K : b) : K = b;
    J = a + L;
    F || (F = !0, window.postMessage(M, "*"));
  };

  p = function p(a, b) {
    E = a;
    G = b;
    I ? window.postMessage(M, "*") : H || (H = !0, A(N));
  };

  n = function n() {
    E = null;
    F = !1;
    G = -1;
  };
}

exports.unstable_scheduleWork = function (a, b) {
  var d = exports.unstable_now();
  b = void 0 !== b && null !== b && null !== b.timeout && void 0 !== b.timeout ? d + b.timeout : d + 5E3;
  a = {
    callback: a,
    timesOutAt: b,
    next: null,
    previous: null
  };
  if (null === c) c = a.next = a.previous = a, m(c);else {
    d = null;
    var k = c;

    do {
      if (k.timesOutAt > b) {
        d = k;
        break;
      }

      k = k.next;
    } while (k !== c);

    null === d ? d = c : d === c && (c = a, m(c));
    b = d.previous;
    b.next = d.previous = a;
    a.next = d;
    a.previous = b;
  }
  return a;
};

exports.unstable_cancelScheduledWork = function (a) {
  var b = a.next;

  if (null !== b) {
    if (b === a) c = null;else {
      a === c && (c = b);
      var d = a.previous;
      d.next = b;
      b.previous = d;
    }
    a.next = a.previous = null;
  }
};